module.exports = __webpack_public_path__ + "img/welcome.bd51d73c.png";